
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire5b49"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire5b49"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("dXDj3", function(module, exports) {

$parcel$export(module.exports, "Router", () => $a29f467d7bec41f6$export$55185c17a0fcbe46);
$parcel$export(module.exports, "Route", () => $a29f467d7bec41f6$export$e7b0ac011bb776c6);
$parcel$export(module.exports, "Link", () => $a29f467d7bec41f6$export$a6c7ac8248d6e38a);

var $g9jCn = parcelRequire("g9jCn");
const { Router: $a29f467d7bec41f6$export$55185c17a0fcbe46, Route: $a29f467d7bec41f6$export$e7b0ac011bb776c6, Link: $a29f467d7bec41f6$export$a6c7ac8248d6e38a } = (0, $g9jCn.createRouter)();

});
parcelRegister("g9jCn", function(module, exports) {

$parcel$export(module.exports, "createRouter", () => $bc1cb4598b74b610$export$baddd0131ee8c05b);
parcelRequire("j7yzP");

var $kdqQ0 = parcelRequire("kdqQ0");

var $8T2E9 = parcelRequire("8T2E9");

var $1jJwX = parcelRequire("1jJwX");

var $dtjlP = parcelRequire("dtjlP");

var $9zAQJ = parcelRequire("9zAQJ");
function $bc1cb4598b74b610$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $bc1cb4598b74b610$var$$3a2ee75a1759d0d8$exports = {};
$bc1cb4598b74b610$var$$parcel$export($bc1cb4598b74b610$var$$3a2ee75a1759d0d8$exports, "RouterMode", ()=>$bc1cb4598b74b610$export$fc55ead6785c2297);
$bc1cb4598b74b610$var$$parcel$export($bc1cb4598b74b610$var$$3a2ee75a1759d0d8$exports, "History", ()=>$bc1cb4598b74b610$export$84202caead5689ba);
var $bc1cb4598b74b610$var$$3a2ee75a1759d0d8$var$__runInitializers = function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $bc1cb4598b74b610$var$$3a2ee75a1759d0d8$var$__esDecorate = function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $bc1cb4598b74b610$var$$3a2ee75a1759d0d8$var$__classPrivateFieldGet = function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $bc1cb4598b74b610$var$$3a2ee75a1759d0d8$var$__classPrivateFieldSet = function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $bc1cb4598b74b610$var$$3a2ee75a1759d0d8$var$_a, $bc1cb4598b74b610$var$$3a2ee75a1759d0d8$var$_b;
const { location: $bc1cb4598b74b610$var$$3a2ee75a1759d0d8$var$location, history: $bc1cb4598b74b610$var$$3a2ee75a1759d0d8$var$history } = window;
const $bc1cb4598b74b610$var$$3a2ee75a1759d0d8$var$basePath = ($bc1cb4598b74b610$var$$3a2ee75a1759d0d8$var$_a = document.querySelector('base')) === null || $bc1cb4598b74b610$var$$3a2ee75a1759d0d8$var$_a === void 0 ? void 0 : $bc1cb4598b74b610$var$$3a2ee75a1759d0d8$var$_a.getAttribute('href');
const $bc1cb4598b74b610$var$$3a2ee75a1759d0d8$var$defaultBaseURL = ($bc1cb4598b74b610$var$$3a2ee75a1759d0d8$var$basePath ? new URL($bc1cb4598b74b610$var$$3a2ee75a1759d0d8$var$basePath, $bc1cb4598b74b610$var$$3a2ee75a1759d0d8$var$location.origin) + '' : $bc1cb4598b74b610$var$$3a2ee75a1759d0d8$var$location.href.split(/\?|#/)[0]).replace(/\/$/, '');
const $bc1cb4598b74b610$var$$3a2ee75a1759d0d8$var$originalTitle = ($bc1cb4598b74b610$var$$3a2ee75a1759d0d8$var$_b = document.querySelector('title')) === null || $bc1cb4598b74b610$var$$3a2ee75a1759d0d8$var$_b === void 0 ? void 0 : $bc1cb4598b74b610$var$$3a2ee75a1759d0d8$var$_b.textContent.trim();
var $bc1cb4598b74b610$export$fc55ead6785c2297;
(function(RouterMode) {
    RouterMode["hash"] = "#";
    RouterMode["history"] = "/";
})($bc1cb4598b74b610$export$fc55ead6785c2297 || ($bc1cb4598b74b610$export$fc55ead6785c2297 = {}));
let $bc1cb4598b74b610$export$84202caead5689ba = (()=>{
    var _a, _History_path_accessor_storage, _History_oldPath_accessor_storage;
    let _instanceExtraInitializers = [];
    let _path_decorators;
    let _path_initializers = [];
    let _path_extraInitializers = [];
    let _oldPath_decorators;
    let _oldPath_initializers = [];
    let _oldPath_extraInitializers = [];
    let _push_decorators;
    return _a = class History {
        get path() {
            return $bc1cb4598b74b610$var$$3a2ee75a1759d0d8$var$__classPrivateFieldGet(this, _History_path_accessor_storage, "f");
        }
        set path(value) {
            $bc1cb4598b74b610$var$$3a2ee75a1759d0d8$var$__classPrivateFieldSet(this, _History_path_accessor_storage, value, "f");
        }
        get oldPath() {
            return $bc1cb4598b74b610$var$$3a2ee75a1759d0d8$var$__classPrivateFieldGet(this, _History_oldPath_accessor_storage, "f");
        }
        set oldPath(value) {
            $bc1cb4598b74b610$var$$3a2ee75a1759d0d8$var$__classPrivateFieldSet(this, _History_oldPath_accessor_storage, value, "f");
        }
        constructor(baseURL = $bc1cb4598b74b610$var$$3a2ee75a1759d0d8$var$defaultBaseURL, delimiter = $bc1cb4598b74b610$export$fc55ead6785c2297.hash){
            Object.defineProperty(this, "baseURL", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($bc1cb4598b74b610$var$$3a2ee75a1759d0d8$var$__runInitializers(this, _instanceExtraInitializers), baseURL)
            });
            Object.defineProperty(this, "delimiter", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: delimiter
            });
            _History_path_accessor_storage.set(this, $bc1cb4598b74b610$var$$3a2ee75a1759d0d8$var$__runInitializers(this, _path_initializers, void 0));
            _History_oldPath_accessor_storage.set(this, ($bc1cb4598b74b610$var$$3a2ee75a1759d0d8$var$__runInitializers(this, _path_extraInitializers), $bc1cb4598b74b610$var$$3a2ee75a1759d0d8$var$__runInitializers(this, _oldPath_initializers, void 0)));
            Object.defineProperty(this, "restore", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($bc1cb4598b74b610$var$$3a2ee75a1759d0d8$var$__runInitializers(this, _oldPath_extraInitializers), ()=>{
                    const { state: state } = $bc1cb4598b74b610$var$$3a2ee75a1759d0d8$var$history;
                    this.push();
                    document.title = (state === null || state === void 0 ? void 0 : state.title) || this.titleOf() || $bc1cb4598b74b610$var$$3a2ee75a1759d0d8$var$originalTitle || $bc1cb4598b74b610$var$$3a2ee75a1759d0d8$var$location.href;
                })
            });
            Object.defineProperty(this, "handleForm", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: (event, form)=>{
                    const { method: method, target: target } = form;
                    if (method !== 'get' || (target || '_self') !== '_self') return;
                    event.preventDefault();
                    const path = form.getAttribute('action'), data = (0, $kdqQ0.buildURLData)((0, $kdqQ0.formToJSON)(form));
                    this.push(`${path}?${data}`);
                }
            });
            this.restore();
            window.addEventListener('hashchange', this.restore);
            window.addEventListener('popstate', this.restore);
            document.addEventListener('click', (0, $kdqQ0.delegate)('a[href], area[href]', this.handleLink.bind(this)));
            document.addEventListener('submit', (0, $kdqQ0.delegate)('form[action]', this.handleForm));
        }
        push(path = $bc1cb4598b74b610$var$$3a2ee75a1759d0d8$var$location.href) {
            var _b;
            path = path.replace(this.baseURL, '');
            if (this.delimiter === $bc1cb4598b74b610$export$fc55ead6785c2297.hash) path = ((_b = path.match(/#.*/)) === null || _b === void 0 ? void 0 : _b[0]) || $bc1cb4598b74b610$export$fc55ead6785c2297.hash;
            if (path === this.path) return path;
            this.oldPath = this.path;
            return this.path = path;
        }
        static dataOf(path) {
            const [before, after] = path.split('#');
            return (0, $kdqQ0.parseURLData)(after || before);
        }
        match(pattern, path = this.path) {
            var _b;
            if (!path) return;
            const { pathname: pathname, hash: hash } = new URLPattern(pattern, this.baseURL).exec(new URL(path.split('?')[0], this.baseURL)) || {};
            return (_b = hash || pathname) === null || _b === void 0 ? void 0 : _b.groups;
        }
        static getTitle(root) {
            return root.title || (0, $kdqQ0.getVisibleText)(root);
        }
        titleOf(path = this.path) {
            path = path.replace(/^\//, '');
            if (path) for (const node of document.querySelectorAll(`a[href="${path}"], area[href="${path}"]`)){
                const title = _a.getTitle(node);
                if (title) return title;
            }
        }
        handleLink(event, link) {
            const path = link.getAttribute('href');
            if ((link.target || '_self') !== '_self' || (0, $kdqQ0.isXDomain)(path) || link.download) return;
            event.preventDefault();
            if (path.startsWith('#')) try {
                if (document.querySelector(path) || path === '#top') return (0, $kdqQ0.scrollTo)(path, event.currentTarget);
            } catch (_b) {}
            const title = _a.getTitle(link);
            $bc1cb4598b74b610$var$$3a2ee75a1759d0d8$var$history.pushState({
                title: title
            }, document.title = title, path);
            this.push(path);
        }
    }, _History_path_accessor_storage = new WeakMap(), _History_oldPath_accessor_storage = new WeakMap(), (()=>{
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
        _path_decorators = [
            (0, $8T2E9.observable)
        ];
        _oldPath_decorators = [
            (0, $8T2E9.observable)
        ];
        _push_decorators = [
            (0, $8T2E9.action)
        ];
        $bc1cb4598b74b610$var$$3a2ee75a1759d0d8$var$__esDecorate(_a, null, _path_decorators, {
            kind: "accessor",
            name: "path",
            static: false,
            private: false,
            access: {
                has: (obj)=>"path" in obj,
                get: (obj)=>obj.path,
                set: (obj, value)=>{
                    obj.path = value;
                }
            },
            metadata: _metadata
        }, _path_initializers, _path_extraInitializers);
        $bc1cb4598b74b610$var$$3a2ee75a1759d0d8$var$__esDecorate(_a, null, _oldPath_decorators, {
            kind: "accessor",
            name: "oldPath",
            static: false,
            private: false,
            access: {
                has: (obj)=>"oldPath" in obj,
                get: (obj)=>obj.oldPath,
                set: (obj, value)=>{
                    obj.oldPath = value;
                }
            },
            metadata: _metadata
        }, _oldPath_initializers, _oldPath_extraInitializers);
        $bc1cb4598b74b610$var$$3a2ee75a1759d0d8$var$__esDecorate(_a, null, _push_decorators, {
            kind: "method",
            name: "push",
            static: false,
            private: false,
            access: {
                has: (obj)=>"push" in obj,
                get: (obj)=>obj.push
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })(), _a;
})();
var $bc1cb4598b74b610$var$$0e8e8fd52ec9970a$exports = {};
$bc1cb4598b74b610$var$$parcel$export($bc1cb4598b74b610$var$$0e8e8fd52ec9970a$exports, "CellRoute", ()=>$bc1cb4598b74b610$export$d6c529ca17cdd16f);
$bc1cb4598b74b610$var$$parcel$export($bc1cb4598b74b610$var$$0e8e8fd52ec9970a$exports, "CellRouter", ()=>$bc1cb4598b74b610$export$b1119cfa2764f723);
var $bc1cb4598b74b610$var$$0e8e8fd52ec9970a$var$__esDecorate = function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $bc1cb4598b74b610$var$$0e8e8fd52ec9970a$var$__runInitializers = function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $bc1cb4598b74b610$var$$0e8e8fd52ec9970a$var$__setFunctionName = function(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
var $bc1cb4598b74b610$var$$0e8e8fd52ec9970a$var$__classPrivateFieldGet = function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $bc1cb4598b74b610$var$$0e8e8fd52ec9970a$var$__classPrivateFieldSet = function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $bc1cb4598b74b610$var$$0e8e8fd52ec9970a$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
let $bc1cb4598b74b610$export$d6c529ca17cdd16f = (()=>{
    var _CellRoute_path_accessor_storage;
    let _classDecorators = [
        (0, $9zAQJ.component)({
            tagName: 'cell-route'
        }),
        (0, $9zAQJ.observer)
    ];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = HTMLElement;
    let _path_decorators;
    let _path_initializers = [];
    let _path_extraInitializers = [];
    var CellRoute = _classThis = class extends _classSuper {
        constructor(){
            super(...arguments);
            _CellRoute_path_accessor_storage.set(this, $bc1cb4598b74b610$var$$0e8e8fd52ec9970a$var$__runInitializers(this, _path_initializers, void 0));
            Object.defineProperty(this, "component", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: $bc1cb4598b74b610$var$$0e8e8fd52ec9970a$var$__runInitializers(this, _path_extraInitializers)
            });
        }
        get path() {
            return $bc1cb4598b74b610$var$$0e8e8fd52ec9970a$var$__classPrivateFieldGet(this, _CellRoute_path_accessor_storage, "f");
        }
        set path(value) {
            $bc1cb4598b74b610$var$$0e8e8fd52ec9970a$var$__classPrivateFieldSet(this, _CellRoute_path_accessor_storage, value, "f");
        }
    };
    _CellRoute_path_accessor_storage = new WeakMap();
    $bc1cb4598b74b610$var$$0e8e8fd52ec9970a$var$__setFunctionName(_classThis, "CellRoute");
    (()=>{
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _path_decorators = [
            (0, $9zAQJ.attribute),
            (0, $8T2E9.observable)
        ];
        $bc1cb4598b74b610$var$$0e8e8fd52ec9970a$var$__esDecorate(_classThis, null, _path_decorators, {
            kind: "accessor",
            name: "path",
            static: false,
            private: false,
            access: {
                has: (obj)=>"path" in obj,
                get: (obj)=>obj.path,
                set: (obj, value)=>{
                    obj.path = value;
                }
            },
            metadata: _metadata
        }, _path_initializers, _path_extraInitializers);
        $bc1cb4598b74b610$var$$0e8e8fd52ec9970a$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        CellRoute = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
        $bc1cb4598b74b610$var$$0e8e8fd52ec9970a$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return CellRoute = _classThis;
})();
let $bc1cb4598b74b610$export$b1119cfa2764f723 = (()=>{
    var _CellRouter_renderer, _CellRouter_history_accessor_storage, _CellRouter_routes_accessor_storage;
    var _a, _b;
    let _classDecorators = [
        (0, $9zAQJ.component)({
            tagName: 'cell-router',
            mode: 'open'
        }),
        (0, $9zAQJ.observer)
    ];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = HTMLElement;
    let _instanceExtraInitializers = [];
    let _history_decorators;
    let _history_initializers = [];
    let _history_extraInitializers = [];
    let _routes_decorators;
    let _routes_initializers = [];
    let _routes_extraInitializers = [];
    let _get_sortedRoutes_decorators;
    let _get_equalRoutes_decorators;
    let _get_matchedRoutes_decorators;
    let _renderChildren_decorators;
    var CellRouter = _classThis = class extends _classSuper {
        constructor(){
            super(...arguments);
            _CellRouter_history_accessor_storage.set(this, ($bc1cb4598b74b610$var$$0e8e8fd52ec9970a$var$__runInitializers(this, _instanceExtraInitializers), $bc1cb4598b74b610$var$$0e8e8fd52ec9970a$var$__runInitializers(this, _history_initializers, void 0)));
            _CellRouter_routes_accessor_storage.set(this, ($bc1cb4598b74b610$var$$0e8e8fd52ec9970a$var$__runInitializers(this, _history_extraInitializers), $bc1cb4598b74b610$var$$0e8e8fd52ec9970a$var$__runInitializers(this, _routes_initializers, [])));
            _CellRouter_renderer.set(this, ($bc1cb4598b74b610$var$$0e8e8fd52ec9970a$var$__runInitializers(this, _routes_extraInitializers), new (0, $dtjlP.DOMRenderer)()));
            Object.defineProperty(this, "handleSlotChange", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ({ currentTarget: currentTarget })=>{
                    const routes = currentTarget.assignedElements().filter((node)=>node instanceof $bc1cb4598b74b610$export$d6c529ca17cdd16f).map(({ path: path, component: component })=>({
                            path: path,
                            component: component
                        }));
                    if (routes[0]) this.routes = routes;
                }
            });
        }
        get history() {
            return $bc1cb4598b74b610$var$$0e8e8fd52ec9970a$var$__classPrivateFieldGet(this, _CellRouter_history_accessor_storage, "f");
        }
        set history(value) {
            $bc1cb4598b74b610$var$$0e8e8fd52ec9970a$var$__classPrivateFieldSet(this, _CellRouter_history_accessor_storage, value, "f");
        }
        get routes() {
            return $bc1cb4598b74b610$var$$0e8e8fd52ec9970a$var$__classPrivateFieldGet(this, _CellRouter_routes_accessor_storage, "f");
        }
        set routes(value) {
            $bc1cb4598b74b610$var$$0e8e8fd52ec9970a$var$__classPrivateFieldSet(this, _CellRouter_routes_accessor_storage, value, "f");
        }
        get sortedRoutes() {
            return [
                ...this.routes
            ].sort(({ path: a }, { path: b })=>b.split('/').length - a.split('/').length || b.length - a.length);
        }
        get equalRoutes() {
            const { history: history, sortedRoutes: sortedRoutes } = this;
            return !history ? [] : sortedRoutes.filter(({ path: path })=>path === history.path);
        }
        get matchedRoutes() {
            const { history: history, sortedRoutes: sortedRoutes } = this;
            return !history ? [] : sortedRoutes.filter(({ path: path })=>history.match(path));
        }
        mountedCallback() {
            this.history || (this.history = new $bc1cb4598b74b610$export$84202caead5689ba());
            this.renderChildren();
        }
        async renderChildren() {
            var _a;
            const { history: history, equalRoutes: equalRoutes, matchedRoutes: matchedRoutes } = this;
            if (!history) return;
            const { path: path } = history;
            const [_b] = [
                ...equalRoutes,
                ...matchedRoutes
            ].map(({ path: path, component: component })=>{
                const matched = history.match(path);
                return matched && Object.assign({
                    component: component
                }, matched);
            }).filter(Boolean), _c = _b === void 0 ? {} : _b, { component: Tag } = _c, matched = $bc1cb4598b74b610$var$$0e8e8fd52ec9970a$var$__rest(_c, [
                "component"
            ]);
            const vNode = Tag ? (0, $1jJwX.jsx)(Tag, Object.assign({}, matched, $bc1cb4598b74b610$export$84202caead5689ba.dataOf(path), {
                path: path,
                history: history
            })) : (0, $1jJwX.jsx)((0, $1jJwX.Fragment), {});
            const render = ()=>{
                $bc1cb4598b74b610$var$$0e8e8fd52ec9970a$var$__classPrivateFieldGet(this, _CellRouter_renderer, "f").render(vNode, this);
                return {};
            };
            const { finished: finished, updateCallbackDone: updateCallbackDone } = ((_a = document.startViewTransition) === null || _a === void 0 ? void 0 : _a.call(document, render)) || render();
            try {
                await finished;
            } catch (_d) {
                return updateCallbackDone;
            }
        }
        render() {
            return (0, $1jJwX.jsx)("slot", {
                onSlotChange: this.handleSlotChange
            });
        }
    };
    _CellRouter_renderer = new WeakMap();
    _CellRouter_history_accessor_storage = new WeakMap();
    _CellRouter_routes_accessor_storage = new WeakMap();
    $bc1cb4598b74b610$var$$0e8e8fd52ec9970a$var$__setFunctionName(_classThis, "CellRouter");
    (()=>{
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _history_decorators = [
            (_a = (0, $8T2E9.observable)).shallow.bind(_a)
        ];
        _routes_decorators = [
            (_b = (0, $8T2E9.observable)).shallow.bind(_b)
        ];
        _get_sortedRoutes_decorators = [
            (0, $8T2E9.computed)
        ];
        _get_equalRoutes_decorators = [
            (0, $8T2E9.computed)
        ];
        _get_matchedRoutes_decorators = [
            (0, $8T2E9.computed)
        ];
        _renderChildren_decorators = [
            (0, $9zAQJ.reaction)(({ history: history })=>history === null || history === void 0 ? void 0 : history.path)
        ];
        $bc1cb4598b74b610$var$$0e8e8fd52ec9970a$var$__esDecorate(_classThis, null, _history_decorators, {
            kind: "accessor",
            name: "history",
            static: false,
            private: false,
            access: {
                has: (obj)=>"history" in obj,
                get: (obj)=>obj.history,
                set: (obj, value)=>{
                    obj.history = value;
                }
            },
            metadata: _metadata
        }, _history_initializers, _history_extraInitializers);
        $bc1cb4598b74b610$var$$0e8e8fd52ec9970a$var$__esDecorate(_classThis, null, _routes_decorators, {
            kind: "accessor",
            name: "routes",
            static: false,
            private: false,
            access: {
                has: (obj)=>"routes" in obj,
                get: (obj)=>obj.routes,
                set: (obj, value)=>{
                    obj.routes = value;
                }
            },
            metadata: _metadata
        }, _routes_initializers, _routes_extraInitializers);
        $bc1cb4598b74b610$var$$0e8e8fd52ec9970a$var$__esDecorate(_classThis, null, _get_sortedRoutes_decorators, {
            kind: "getter",
            name: "sortedRoutes",
            static: false,
            private: false,
            access: {
                has: (obj)=>"sortedRoutes" in obj,
                get: (obj)=>obj.sortedRoutes
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $bc1cb4598b74b610$var$$0e8e8fd52ec9970a$var$__esDecorate(_classThis, null, _get_equalRoutes_decorators, {
            kind: "getter",
            name: "equalRoutes",
            static: false,
            private: false,
            access: {
                has: (obj)=>"equalRoutes" in obj,
                get: (obj)=>obj.equalRoutes
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $bc1cb4598b74b610$var$$0e8e8fd52ec9970a$var$__esDecorate(_classThis, null, _get_matchedRoutes_decorators, {
            kind: "getter",
            name: "matchedRoutes",
            static: false,
            private: false,
            access: {
                has: (obj)=>"matchedRoutes" in obj,
                get: (obj)=>obj.matchedRoutes
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $bc1cb4598b74b610$var$$0e8e8fd52ec9970a$var$__esDecorate(_classThis, null, _renderChildren_decorators, {
            kind: "method",
            name: "renderChildren",
            static: false,
            private: false,
            access: {
                has: (obj)=>"renderChildren" in obj,
                get: (obj)=>obj.renderChildren
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $bc1cb4598b74b610$var$$0e8e8fd52ec9970a$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        CellRouter = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
        $bc1cb4598b74b610$var$$0e8e8fd52ec9970a$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return CellRouter = _classThis;
})();
var $bc1cb4598b74b610$var$$3d03e8579c0b9ff1$exports = {};
var $bc1cb4598b74b610$var$$7b488c9460f448a0$exports = {};
$bc1cb4598b74b610$var$$parcel$export($bc1cb4598b74b610$var$$7b488c9460f448a0$exports, "createRouter", ()=>$bc1cb4598b74b610$export$baddd0131ee8c05b);
var $bc1cb4598b74b610$var$$7b488c9460f448a0$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $bc1cb4598b74b610$export$baddd0131ee8c05b({ mode: mode = 'hash', linkTags: linkTags } = {}) {
    const prefix = $bc1cb4598b74b610$export$fc55ead6785c2297[mode];
    const extraComponentList = Object.entries(linkTags || {}).map(([name, Component])=>[
            name,
            (_a)=>{
                var { href: href } = _a, props = $bc1cb4598b74b610$var$$7b488c9460f448a0$var$__rest(_a, [
                    "href"
                ]);
                return (0, $1jJwX.jsx)(Component, Object.assign({}, props, {
                    href: prefix + (href || '')
                }));
            }
        ]);
    const extraComponentMap = Object.fromEntries(extraComponentList);
    return Object.assign(Object.assign({}, extraComponentMap), {
        Router: (_a)=>{
            var { routes: routes } = _a, props = $bc1cb4598b74b610$var$$7b488c9460f448a0$var$__rest(_a, [
                "routes"
            ]);
            return (0, $1jJwX.jsx)($bc1cb4598b74b610$export$b1119cfa2764f723, Object.assign({}, props, {
                routes: routes === null || routes === void 0 ? void 0 : routes.map((_a)=>{
                    var { path: path } = _a, route = $bc1cb4598b74b610$var$$7b488c9460f448a0$var$__rest(_a, [
                        "path"
                    ]);
                    return Object.assign(Object.assign({}, route), {
                        path: path != null ? `${prefix}${path}` : path
                    });
                })
            }));
        },
        Route: (_a)=>{
            var { path: path } = _a, props = $bc1cb4598b74b610$var$$7b488c9460f448a0$var$__rest(_a, [
                "path"
            ]);
            return (0, $1jJwX.jsx)($bc1cb4598b74b610$export$d6c529ca17cdd16f, Object.assign({}, props, {
                path: path != null ? `${prefix}${path}` : path
            }));
        },
        Link: (_a)=>{
            var { to: to, children: children } = _a, props = $bc1cb4598b74b610$var$$7b488c9460f448a0$var$__rest(_a, [
                "to",
                "children"
            ]);
            return (0, $1jJwX.jsx)("a", Object.assign({}, props, {
                href: prefix + to,
                children: children
            }));
        },
        Form: (_a)=>{
            var { action: action, children: children } = _a, props = $bc1cb4598b74b610$var$$7b488c9460f448a0$var$__rest(_a, [
                "action",
                "children"
            ]);
            return (0, $1jJwX.jsx)("form", Object.assign({}, props, {
                action: prefix + action,
                children: children
            }));
        }
    });
}

});
parcelRegister("j7yzP", function(module, exports) {

var $aaRfN = parcelRequire("aaRfN");
if (!globalThis.URLPattern) globalThis.URLPattern = (0, $aaRfN.URLPattern);

});
parcelRegister("aaRfN", function(module, exports) {

$parcel$export(module.exports, "URLPattern", () => $768425a223677417$export$a348b14d2b61192c);
var $768425a223677417$var$Pe = Object.defineProperty;
var $768425a223677417$var$a = (e, t)=>$768425a223677417$var$Pe(e, "name", {
        value: t,
        configurable: !0
    });
var $768425a223677417$var$P = class {
    type = 3;
    name = "";
    prefix = "";
    value = "";
    suffix = "";
    modifier = 3;
    constructor(t, r, n, c, l, f){
        this.type = t, this.name = r, this.prefix = n, this.value = c, this.suffix = l, this.modifier = f;
    }
    hasCustomName() {
        return this.name !== "" && typeof this.name != "number";
    }
};
$768425a223677417$var$a($768425a223677417$var$P, "Part");
var $768425a223677417$var$Re = /[$_\p{ID_Start}]/u, $768425a223677417$var$Ee = /[$_\u200C\u200D\p{ID_Continue}]/u, $768425a223677417$var$v = ".*";
function $768425a223677417$var$Oe(e, t) {
    return (t ? /^[\x00-\xFF]*$/ : /^[\x00-\x7F]*$/).test(e);
}
$768425a223677417$var$a($768425a223677417$var$Oe, "isASCII");
function $768425a223677417$var$D(e, t = !1) {
    let r = [], n = 0;
    for(; n < e.length;){
        let c = e[n], l = $768425a223677417$var$a(function(f) {
            if (!t) throw new TypeError(f);
            r.push({
                type: "INVALID_CHAR",
                index: n,
                value: e[n++]
            });
        }, "ErrorOrInvalid");
        if (c === "*") {
            r.push({
                type: "ASTERISK",
                index: n,
                value: e[n++]
            });
            continue;
        }
        if (c === "+" || c === "?") {
            r.push({
                type: "OTHER_MODIFIER",
                index: n,
                value: e[n++]
            });
            continue;
        }
        if (c === "\\") {
            r.push({
                type: "ESCAPED_CHAR",
                index: n++,
                value: e[n++]
            });
            continue;
        }
        if (c === "{") {
            r.push({
                type: "OPEN",
                index: n,
                value: e[n++]
            });
            continue;
        }
        if (c === "}") {
            r.push({
                type: "CLOSE",
                index: n,
                value: e[n++]
            });
            continue;
        }
        if (c === ":") {
            let f = "", s = n + 1;
            for(; s < e.length;){
                let i = e.substr(s, 1);
                if (s === n + 1 && $768425a223677417$var$Re.test(i) || s !== n + 1 && $768425a223677417$var$Ee.test(i)) {
                    f += e[s++];
                    continue;
                }
                break;
            }
            if (!f) {
                l(`Missing parameter name at ${n}`);
                continue;
            }
            r.push({
                type: "NAME",
                index: n,
                value: f
            }), n = s;
            continue;
        }
        if (c === "(") {
            let f = 1, s = "", i = n + 1, o = !1;
            if (e[i] === "?") {
                l(`Pattern cannot start with "?" at ${i}`);
                continue;
            }
            for(; i < e.length;){
                if (!$768425a223677417$var$Oe(e[i], !1)) {
                    l(`Invalid character '${e[i]}' at ${i}.`), o = !0;
                    break;
                }
                if (e[i] === "\\") {
                    s += e[i++] + e[i++];
                    continue;
                }
                if (e[i] === ")") {
                    if (f--, f === 0) {
                        i++;
                        break;
                    }
                } else if (e[i] === "(" && (f++, e[i + 1] !== "?")) {
                    l(`Capturing groups are not allowed at ${i}`), o = !0;
                    break;
                }
                s += e[i++];
            }
            if (o) continue;
            if (f) {
                l(`Unbalanced pattern at ${n}`);
                continue;
            }
            if (!s) {
                l(`Missing pattern at ${n}`);
                continue;
            }
            r.push({
                type: "REGEX",
                index: n,
                value: s
            }), n = i;
            continue;
        }
        r.push({
            type: "CHAR",
            index: n,
            value: e[n++]
        });
    }
    return r.push({
        type: "END",
        index: n,
        value: ""
    }), r;
}
$768425a223677417$var$a($768425a223677417$var$D, "lexer");
function $768425a223677417$var$F(e, t = {}) {
    let r = $768425a223677417$var$D(e);
    t.delimiter ??= "/#?", t.prefixes ??= "./";
    let n = `[^${$768425a223677417$var$x(t.delimiter)}]+?`, c = [], l = 0, f = 0, s = "", i = new Set, o = $768425a223677417$var$a((u)=>{
        if (f < r.length && r[f].type === u) return r[f++].value;
    }, "tryConsume"), h = $768425a223677417$var$a(()=>o("OTHER_MODIFIER") ?? o("ASTERISK"), "tryConsumeModifier"), p = $768425a223677417$var$a((u)=>{
        let d = o(u);
        if (d !== void 0) return d;
        let { type: g, index: y } = r[f];
        throw new TypeError(`Unexpected ${g} at ${y}, expected ${u}`);
    }, "mustConsume"), A = $768425a223677417$var$a(()=>{
        let u = "", d;
        for(; d = o("CHAR") ?? o("ESCAPED_CHAR");)u += d;
        return u;
    }, "consumeText"), xe = $768425a223677417$var$a((u)=>u, "DefaultEncodePart"), N = t.encodePart || xe, H = "", $ = $768425a223677417$var$a((u)=>{
        H += u;
    }, "appendToPendingFixedValue"), M = $768425a223677417$var$a(()=>{
        H.length && (c.push(new $768425a223677417$var$P(3, "", "", N(H), "", 3)), H = "");
    }, "maybeAddPartFromPendingFixedValue"), X = $768425a223677417$var$a((u, d, g, y, Z)=>{
        let m = 3;
        switch(Z){
            case "?":
                m = 1;
                break;
            case "*":
                m = 0;
                break;
            case "+":
                m = 2;
                break;
        }
        if (!d && !g && m === 3) {
            $(u);
            return;
        }
        if (M(), !d && !g) {
            if (!u) return;
            c.push(new $768425a223677417$var$P(3, "", "", N(u), "", m));
            return;
        }
        let S;
        g ? g === "*" ? S = $768425a223677417$var$v : S = g : S = n;
        let k = 2;
        S === n ? (k = 1, S = "") : S === $768425a223677417$var$v && (k = 0, S = "");
        let E;
        if (d ? E = d : g && (E = l++), i.has(E)) throw new TypeError(`Duplicate name '${E}'.`);
        i.add(E), c.push(new $768425a223677417$var$P(k, E, N(u), S, N(y), m));
    }, "addPart");
    for(; f < r.length;){
        let u = o("CHAR"), d = o("NAME"), g = o("REGEX");
        if (!d && !g && (g = o("ASTERISK")), d || g) {
            let m = u ?? "";
            t.prefixes.indexOf(m) === -1 && ($(m), m = ""), M();
            let S = h();
            X(m, d, g, "", S);
            continue;
        }
        let y = u ?? o("ESCAPED_CHAR");
        if (y) {
            $(y);
            continue;
        }
        if (o("OPEN")) {
            let m = A(), S = o("NAME"), k = o("REGEX");
            !S && !k && (k = o("ASTERISK"));
            let E = A();
            p("CLOSE");
            let be = h();
            X(m, S, k, E, be);
            continue;
        }
        M(), p("END");
    }
    return c;
}
$768425a223677417$var$a($768425a223677417$var$F, "parse");
function $768425a223677417$var$x(e) {
    return e.replace(/([.+*?^${}()[\]|/\\])/g, "\\$1");
}
$768425a223677417$var$a($768425a223677417$var$x, "escapeString");
function $768425a223677417$var$B(e) {
    return e && e.ignoreCase ? "ui" : "u";
}
$768425a223677417$var$a($768425a223677417$var$B, "flags");
function $768425a223677417$var$q(e, t, r) {
    return $768425a223677417$var$W($768425a223677417$var$F(e, r), t, r);
}
$768425a223677417$var$a($768425a223677417$var$q, "stringToRegexp");
function $768425a223677417$var$T(e) {
    switch(e){
        case 0:
            return "*";
        case 1:
            return "?";
        case 2:
            return "+";
        case 3:
            return "";
    }
}
$768425a223677417$var$a($768425a223677417$var$T, "modifierToString");
function $768425a223677417$var$W(e, t, r = {}) {
    r.delimiter ??= "/#?", r.prefixes ??= "./", r.sensitive ??= !1, r.strict ??= !1, r.end ??= !0, r.start ??= !0, r.endsWith = "";
    let n = r.start ? "^" : "";
    for (let s of e){
        if (s.type === 3) {
            s.modifier === 3 ? n += $768425a223677417$var$x(s.value) : n += `(?:${$768425a223677417$var$x(s.value)})${$768425a223677417$var$T(s.modifier)}`;
            continue;
        }
        t && t.push(s.name);
        let i = `[^${$768425a223677417$var$x(r.delimiter)}]+?`, o = s.value;
        if (s.type === 1 ? o = i : s.type === 0 && (o = $768425a223677417$var$v), !s.prefix.length && !s.suffix.length) {
            s.modifier === 3 || s.modifier === 1 ? n += `(${o})${$768425a223677417$var$T(s.modifier)}` : n += `((?:${o})${$768425a223677417$var$T(s.modifier)})`;
            continue;
        }
        if (s.modifier === 3 || s.modifier === 1) {
            n += `(?:${$768425a223677417$var$x(s.prefix)}(${o})${$768425a223677417$var$x(s.suffix)})`, n += $768425a223677417$var$T(s.modifier);
            continue;
        }
        n += `(?:${$768425a223677417$var$x(s.prefix)}`, n += `((?:${o})(?:`, n += $768425a223677417$var$x(s.suffix), n += $768425a223677417$var$x(s.prefix), n += `(?:${o}))*)${$768425a223677417$var$x(s.suffix)})`, s.modifier === 0 && (n += "?");
    }
    let c = `[${$768425a223677417$var$x(r.endsWith)}]|$`, l = `[${$768425a223677417$var$x(r.delimiter)}]`;
    if (r.end) return r.strict || (n += `${l}?`), r.endsWith.length ? n += `(?=${c})` : n += "$", new RegExp(n, $768425a223677417$var$B(r));
    r.strict || (n += `(?:${l}(?=${c}))?`);
    let f = !1;
    if (e.length) {
        let s = e[e.length - 1];
        s.type === 3 && s.modifier === 3 && (f = r.delimiter.indexOf(s) > -1);
    }
    return f || (n += `(?=${l}|${c})`), new RegExp(n, $768425a223677417$var$B(r));
}
$768425a223677417$var$a($768425a223677417$var$W, "partsToRegexp");
var $768425a223677417$var$b = {
    delimiter: "",
    prefixes: "",
    sensitive: !0,
    strict: !0
}, $768425a223677417$var$J = {
    delimiter: ".",
    prefixes: "",
    sensitive: !0,
    strict: !0
}, $768425a223677417$var$Q = {
    delimiter: "/",
    prefixes: "/",
    sensitive: !0,
    strict: !0
};
function $768425a223677417$var$ee(e, t) {
    return e.length ? e[0] === "/" ? !0 : !t || e.length < 2 ? !1 : (e[0] == "\\" || e[0] == "{") && e[1] == "/" : !1;
}
$768425a223677417$var$a($768425a223677417$var$ee, "isAbsolutePathname");
function $768425a223677417$var$te(e, t) {
    return e.startsWith(t) ? e.substring(t.length, e.length) : e;
}
$768425a223677417$var$a($768425a223677417$var$te, "maybeStripPrefix");
function $768425a223677417$var$ke(e, t) {
    return e.endsWith(t) ? e.substr(0, e.length - t.length) : e;
}
$768425a223677417$var$a($768425a223677417$var$ke, "maybeStripSuffix");
function $768425a223677417$var$_(e) {
    return !e || e.length < 2 ? !1 : e[0] === "[" || (e[0] === "\\" || e[0] === "{") && e[1] === "[";
}
$768425a223677417$var$a($768425a223677417$var$_, "treatAsIPv6Hostname");
var $768425a223677417$var$re = [
    "ftp",
    "file",
    "http",
    "https",
    "ws",
    "wss"
];
function $768425a223677417$var$U(e) {
    if (!e) return !0;
    for (let t of $768425a223677417$var$re)if (e.test(t)) return !0;
    return !1;
}
$768425a223677417$var$a($768425a223677417$var$U, "isSpecialScheme");
function $768425a223677417$var$ne(e, t) {
    if (e = $768425a223677417$var$te(e, "#"), t || e === "") return e;
    let r = new URL("https://example.com");
    return r.hash = e, r.hash ? r.hash.substring(1, r.hash.length) : "";
}
$768425a223677417$var$a($768425a223677417$var$ne, "canonicalizeHash");
function $768425a223677417$var$se(e, t) {
    if (e = $768425a223677417$var$te(e, "?"), t || e === "") return e;
    let r = new URL("https://example.com");
    return r.search = e, r.search ? r.search.substring(1, r.search.length) : "";
}
$768425a223677417$var$a($768425a223677417$var$se, "canonicalizeSearch");
function $768425a223677417$var$ie(e, t) {
    return t || e === "" ? e : $768425a223677417$var$_(e) ? $768425a223677417$var$K(e) : $768425a223677417$var$j(e);
}
$768425a223677417$var$a($768425a223677417$var$ie, "canonicalizeHostname");
function $768425a223677417$var$ae(e, t) {
    if (t || e === "") return e;
    let r = new URL("https://example.com");
    return r.password = e, r.password;
}
$768425a223677417$var$a($768425a223677417$var$ae, "canonicalizePassword");
function $768425a223677417$var$oe(e, t) {
    if (t || e === "") return e;
    let r = new URL("https://example.com");
    return r.username = e, r.username;
}
$768425a223677417$var$a($768425a223677417$var$oe, "canonicalizeUsername");
function $768425a223677417$var$ce(e, t, r) {
    if (r || e === "") return e;
    if (t && !$768425a223677417$var$re.includes(t)) return new URL(`${t}:${e}`).pathname;
    let n = e[0] == "/";
    return e = new URL(n ? e : "/-" + e, "https://example.com").pathname, n || (e = e.substring(2, e.length)), e;
}
$768425a223677417$var$a($768425a223677417$var$ce, "canonicalizePathname");
function $768425a223677417$var$le(e, t, r) {
    return $768425a223677417$var$z(t) === e && (e = ""), r || e === "" ? e : $768425a223677417$var$G(e);
}
$768425a223677417$var$a($768425a223677417$var$le, "canonicalizePort");
function $768425a223677417$var$fe(e, t) {
    return e = $768425a223677417$var$ke(e, ":"), t || e === "" ? e : $768425a223677417$var$w(e);
}
$768425a223677417$var$a($768425a223677417$var$fe, "canonicalizeProtocol");
function $768425a223677417$var$z(e) {
    switch(e){
        case "ws":
        case "http":
            return "80";
        case "wws":
        case "https":
            return "443";
        case "ftp":
            return "21";
        default:
            return "";
    }
}
$768425a223677417$var$a($768425a223677417$var$z, "defaultPortForProtocol");
function $768425a223677417$var$w(e) {
    if (e === "") return e;
    if (/^[-+.A-Za-z0-9]*$/.test(e)) return e.toLowerCase();
    throw new TypeError(`Invalid protocol '${e}'.`);
}
$768425a223677417$var$a($768425a223677417$var$w, "protocolEncodeCallback");
function $768425a223677417$var$he(e) {
    if (e === "") return e;
    let t = new URL("https://example.com");
    return t.username = e, t.username;
}
$768425a223677417$var$a($768425a223677417$var$he, "usernameEncodeCallback");
function $768425a223677417$var$ue(e) {
    if (e === "") return e;
    let t = new URL("https://example.com");
    return t.password = e, t.password;
}
$768425a223677417$var$a($768425a223677417$var$ue, "passwordEncodeCallback");
function $768425a223677417$var$j(e) {
    if (e === "") return e;
    if (/[\t\n\r #%/:<>?@[\]^\\|]/g.test(e)) throw new TypeError(`Invalid hostname '${e}'`);
    let t = new URL("https://example.com");
    return t.hostname = e, t.hostname;
}
$768425a223677417$var$a($768425a223677417$var$j, "hostnameEncodeCallback");
function $768425a223677417$var$K(e) {
    if (e === "") return e;
    if (/[^0-9a-fA-F[\]:]/g.test(e)) throw new TypeError(`Invalid IPv6 hostname '${e}'`);
    return e.toLowerCase();
}
$768425a223677417$var$a($768425a223677417$var$K, "ipv6HostnameEncodeCallback");
function $768425a223677417$var$G(e) {
    if (e === "" || /^[0-9]*$/.test(e) && parseInt(e) <= 65535) return e;
    throw new TypeError(`Invalid port '${e}'.`);
}
$768425a223677417$var$a($768425a223677417$var$G, "portEncodeCallback");
function $768425a223677417$var$de(e) {
    if (e === "") return e;
    let t = new URL("https://example.com");
    return t.pathname = e[0] !== "/" ? "/-" + e : e, e[0] !== "/" ? t.pathname.substring(2, t.pathname.length) : t.pathname;
}
$768425a223677417$var$a($768425a223677417$var$de, "standardURLPathnameEncodeCallback");
function $768425a223677417$var$pe(e) {
    return e === "" ? e : new URL(`data:${e}`).pathname;
}
$768425a223677417$var$a($768425a223677417$var$pe, "pathURLPathnameEncodeCallback");
function $768425a223677417$var$ge(e) {
    if (e === "") return e;
    let t = new URL("https://example.com");
    return t.search = e, t.search.substring(1, t.search.length);
}
$768425a223677417$var$a($768425a223677417$var$ge, "searchEncodeCallback");
function $768425a223677417$var$me(e) {
    if (e === "") return e;
    let t = new URL("https://example.com");
    return t.hash = e, t.hash.substring(1, t.hash.length);
}
$768425a223677417$var$a($768425a223677417$var$me, "hashEncodeCallback");
var $768425a223677417$var$C = class {
    #i;
    #n = [];
    #t = {};
    #e = 0;
    #s = 1;
    #l = 0;
    #o = 0;
    #d = 0;
    #p = 0;
    #g = !1;
    constructor(t){
        this.#i = t;
    }
    get result() {
        return this.#t;
    }
    parse() {
        for(this.#n = $768425a223677417$var$D(this.#i, !0); this.#e < this.#n.length; this.#e += this.#s){
            if (this.#s = 1, this.#n[this.#e].type === "END") {
                if (this.#o === 0) {
                    this.#b(), this.#f() ? this.#r(9, 1) : this.#h() ? this.#r(8, 1) : this.#r(7, 0);
                    continue;
                } else if (this.#o === 2) {
                    this.#u(5);
                    continue;
                }
                this.#r(10, 0);
                break;
            }
            if (this.#d > 0) {
                if (this.#A()) this.#d -= 1;
                else continue;
            }
            if (this.#T()) {
                this.#d += 1;
                continue;
            }
            switch(this.#o){
                case 0:
                    this.#P() && this.#u(1);
                    break;
                case 1:
                    if (this.#P()) {
                        this.#C();
                        let t = 7, r = 1;
                        this.#E() ? (t = 2, r = 3) : this.#g && (t = 2), this.#r(t, r);
                    }
                    break;
                case 2:
                    this.#S() ? this.#u(3) : (this.#x() || this.#h() || this.#f()) && this.#u(5);
                    break;
                case 3:
                    this.#O() ? this.#r(4, 1) : this.#S() && this.#r(5, 1);
                    break;
                case 4:
                    this.#S() && this.#r(5, 1);
                    break;
                case 5:
                    this.#y() ? this.#p += 1 : this.#w() && (this.#p -= 1), this.#k() && !this.#p ? this.#r(6, 1) : this.#x() ? this.#r(7, 0) : this.#h() ? this.#r(8, 1) : this.#f() && this.#r(9, 1);
                    break;
                case 6:
                    this.#x() ? this.#r(7, 0) : this.#h() ? this.#r(8, 1) : this.#f() && this.#r(9, 1);
                    break;
                case 7:
                    this.#h() ? this.#r(8, 1) : this.#f() && this.#r(9, 1);
                    break;
                case 8:
                    this.#f() && this.#r(9, 1);
                    break;
                case 9:
                    break;
                case 10:
                    break;
            }
        }
        this.#t.hostname !== void 0 && this.#t.port === void 0 && (this.#t.port = "");
    }
    #r(t, r) {
        switch(this.#o){
            case 0:
                break;
            case 1:
                this.#t.protocol = this.#c();
                break;
            case 2:
                break;
            case 3:
                this.#t.username = this.#c();
                break;
            case 4:
                this.#t.password = this.#c();
                break;
            case 5:
                this.#t.hostname = this.#c();
                break;
            case 6:
                this.#t.port = this.#c();
                break;
            case 7:
                this.#t.pathname = this.#c();
                break;
            case 8:
                this.#t.search = this.#c();
                break;
            case 9:
                this.#t.hash = this.#c();
                break;
            case 10:
                break;
        }
        this.#o !== 0 && t !== 10 && ([
            1,
            2,
            3,
            4
        ].includes(this.#o) && [
            6,
            7,
            8,
            9
        ].includes(t) && (this.#t.hostname ??= ""), [
            1,
            2,
            3,
            4,
            5,
            6
        ].includes(this.#o) && [
            8,
            9
        ].includes(t) && (this.#t.pathname ??= this.#g ? "/" : ""), [
            1,
            2,
            3,
            4,
            5,
            6,
            7
        ].includes(this.#o) && t === 9 && (this.#t.search ??= "")), this.#R(t, r);
    }
    #R(t, r) {
        this.#o = t, this.#l = this.#e + r, this.#e += r, this.#s = 0;
    }
    #b() {
        this.#e = this.#l, this.#s = 0;
    }
    #u(t) {
        this.#b(), this.#o = t;
    }
    #m(t) {
        return t < 0 && (t = this.#n.length - t), t < this.#n.length ? this.#n[t] : this.#n[this.#n.length - 1];
    }
    #a(t, r) {
        let n = this.#m(t);
        return n.value === r && (n.type === "CHAR" || n.type === "ESCAPED_CHAR" || n.type === "INVALID_CHAR");
    }
    #P() {
        return this.#a(this.#e, ":");
    }
    #E() {
        return this.#a(this.#e + 1, "/") && this.#a(this.#e + 2, "/");
    }
    #S() {
        return this.#a(this.#e, "@");
    }
    #O() {
        return this.#a(this.#e, ":");
    }
    #k() {
        return this.#a(this.#e, ":");
    }
    #x() {
        return this.#a(this.#e, "/");
    }
    #h() {
        if (this.#a(this.#e, "?")) return !0;
        if (this.#n[this.#e].value !== "?") return !1;
        let t = this.#m(this.#e - 1);
        return t.type !== "NAME" && t.type !== "REGEX" && t.type !== "CLOSE" && t.type !== "ASTERISK";
    }
    #f() {
        return this.#a(this.#e, "#");
    }
    #T() {
        return this.#n[this.#e].type == "OPEN";
    }
    #A() {
        return this.#n[this.#e].type == "CLOSE";
    }
    #y() {
        return this.#a(this.#e, "[");
    }
    #w() {
        return this.#a(this.#e, "]");
    }
    #c() {
        let t = this.#n[this.#e], r = this.#m(this.#l).index;
        return this.#i.substring(r, t.index);
    }
    #C() {
        let t = {};
        Object.assign(t, $768425a223677417$var$b), t.encodePart = $768425a223677417$var$w;
        let r = $768425a223677417$var$q(this.#c(), void 0, t);
        this.#g = $768425a223677417$var$U(r);
    }
};
$768425a223677417$var$a($768425a223677417$var$C, "Parser");
var $768425a223677417$var$V = [
    "protocol",
    "username",
    "password",
    "hostname",
    "port",
    "pathname",
    "search",
    "hash"
], $768425a223677417$var$O = "*";
function $768425a223677417$var$Se(e, t) {
    if (typeof e != "string") throw new TypeError("parameter 1 is not of type 'string'.");
    let r = new URL(e, t);
    return {
        protocol: r.protocol.substring(0, r.protocol.length - 1),
        username: r.username,
        password: r.password,
        hostname: r.hostname,
        port: r.port,
        pathname: r.pathname,
        search: r.search !== "" ? r.search.substring(1, r.search.length) : void 0,
        hash: r.hash !== "" ? r.hash.substring(1, r.hash.length) : void 0
    };
}
$768425a223677417$var$a($768425a223677417$var$Se, "extractValues");
function $768425a223677417$var$R(e, t) {
    return t ? $768425a223677417$var$I(e) : e;
}
$768425a223677417$var$a($768425a223677417$var$R, "processBaseURLString");
function $768425a223677417$var$L(e, t, r) {
    let n;
    if (typeof t.baseURL == "string") try {
        n = new URL(t.baseURL), t.protocol === void 0 && (e.protocol = $768425a223677417$var$R(n.protocol.substring(0, n.protocol.length - 1), r)), !r && t.protocol === void 0 && t.hostname === void 0 && t.port === void 0 && t.username === void 0 && (e.username = $768425a223677417$var$R(n.username, r)), !r && t.protocol === void 0 && t.hostname === void 0 && t.port === void 0 && t.username === void 0 && t.password === void 0 && (e.password = $768425a223677417$var$R(n.password, r)), t.protocol === void 0 && t.hostname === void 0 && (e.hostname = $768425a223677417$var$R(n.hostname, r)), t.protocol === void 0 && t.hostname === void 0 && t.port === void 0 && (e.port = $768425a223677417$var$R(n.port, r)), t.protocol === void 0 && t.hostname === void 0 && t.port === void 0 && t.pathname === void 0 && (e.pathname = $768425a223677417$var$R(n.pathname, r)), t.protocol === void 0 && t.hostname === void 0 && t.port === void 0 && t.pathname === void 0 && t.search === void 0 && (e.search = $768425a223677417$var$R(n.search.substring(1, n.search.length), r)), t.protocol === void 0 && t.hostname === void 0 && t.port === void 0 && t.pathname === void 0 && t.search === void 0 && t.hash === void 0 && (e.hash = $768425a223677417$var$R(n.hash.substring(1, n.hash.length), r));
    } catch  {
        throw new TypeError(`invalid baseURL '${t.baseURL}'.`);
    }
    if (typeof t.protocol == "string" && (e.protocol = $768425a223677417$var$fe(t.protocol, r)), typeof t.username == "string" && (e.username = $768425a223677417$var$oe(t.username, r)), typeof t.password == "string" && (e.password = $768425a223677417$var$ae(t.password, r)), typeof t.hostname == "string" && (e.hostname = $768425a223677417$var$ie(t.hostname, r)), typeof t.port == "string" && (e.port = $768425a223677417$var$le(t.port, e.protocol, r)), typeof t.pathname == "string") {
        if (e.pathname = t.pathname, n && !$768425a223677417$var$ee(e.pathname, r)) {
            let c = n.pathname.lastIndexOf("/");
            c >= 0 && (e.pathname = $768425a223677417$var$R(n.pathname.substring(0, c + 1), r) + e.pathname);
        }
        e.pathname = $768425a223677417$var$ce(e.pathname, e.protocol, r);
    }
    return typeof t.search == "string" && (e.search = $768425a223677417$var$se(t.search, r)), typeof t.hash == "string" && (e.hash = $768425a223677417$var$ne(t.hash, r)), e;
}
$768425a223677417$var$a($768425a223677417$var$L, "applyInit");
function $768425a223677417$var$I(e) {
    return e.replace(/([+*?:{}()\\])/g, "\\$1");
}
$768425a223677417$var$a($768425a223677417$var$I, "escapePatternString");
function $768425a223677417$var$Te(e) {
    return e.replace(/([.+*?^${}()[\]|/\\])/g, "\\$1");
}
$768425a223677417$var$a($768425a223677417$var$Te, "escapeRegexpString");
function $768425a223677417$var$Ae(e, t) {
    t.delimiter ??= "/#?", t.prefixes ??= "./", t.sensitive ??= !1, t.strict ??= !1, t.end ??= !0, t.start ??= !0, t.endsWith = "";
    let r = ".*", n = `[^${$768425a223677417$var$Te(t.delimiter)}]+?`, c = /[$_\u200C\u200D\p{ID_Continue}]/u, l = "";
    for(let f = 0; f < e.length; ++f){
        let s = e[f];
        if (s.type === 3) {
            if (s.modifier === 3) {
                l += $768425a223677417$var$I(s.value);
                continue;
            }
            l += `{${$768425a223677417$var$I(s.value)}}${$768425a223677417$var$T(s.modifier)}`;
            continue;
        }
        let i = s.hasCustomName(), o = !!s.suffix.length || !!s.prefix.length && (s.prefix.length !== 1 || !t.prefixes.includes(s.prefix)), h = f > 0 ? e[f - 1] : null, p = f < e.length - 1 ? e[f + 1] : null;
        if (!o && i && s.type === 1 && s.modifier === 3 && p && !p.prefix.length && !p.suffix.length) {
            if (p.type === 3) {
                let A = p.value.length > 0 ? p.value[0] : "";
                o = c.test(A);
            } else o = !p.hasCustomName();
        }
        if (!o && !s.prefix.length && h && h.type === 3) {
            let A = h.value[h.value.length - 1];
            o = t.prefixes.includes(A);
        }
        o && (l += "{"), l += $768425a223677417$var$I(s.prefix), i && (l += `:${s.name}`), s.type === 2 ? l += `(${s.value})` : s.type === 1 ? i || (l += `(${n})`) : s.type === 0 && (!i && (!h || h.type === 3 || h.modifier !== 3 || o || s.prefix !== "") ? l += "*" : l += `(${r})`), s.type === 1 && i && s.suffix.length && c.test(s.suffix[0]) && (l += "\\"), l += $768425a223677417$var$I(s.suffix), o && (l += "}"), s.modifier !== 3 && (l += $768425a223677417$var$T(s.modifier));
    }
    return l;
}
$768425a223677417$var$a($768425a223677417$var$Ae, "partsToPattern");
var $768425a223677417$export$a348b14d2b61192c = class {
    #i;
    #n = {};
    #t = {};
    #e = {};
    #s = {};
    #l = !1;
    constructor(t = {}, r, n){
        try {
            let c;
            if (typeof r == "string" ? c = r : n = r, typeof t == "string") {
                let i = new $768425a223677417$var$C(t);
                if (i.parse(), t = i.result, c === void 0 && typeof t.protocol != "string") throw new TypeError("A base URL must be provided for a relative constructor string.");
                t.baseURL = c;
            } else {
                if (!t || typeof t != "object") throw new TypeError("parameter 1 is not of type 'string' and cannot convert to dictionary.");
                if (c) throw new TypeError("parameter 1 is not of type 'string'.");
            }
            typeof n > "u" && (n = {
                ignoreCase: !1
            });
            let l = {
                ignoreCase: n.ignoreCase === !0
            }, f = {
                pathname: $768425a223677417$var$O,
                protocol: $768425a223677417$var$O,
                username: $768425a223677417$var$O,
                password: $768425a223677417$var$O,
                hostname: $768425a223677417$var$O,
                port: $768425a223677417$var$O,
                search: $768425a223677417$var$O,
                hash: $768425a223677417$var$O
            };
            this.#i = $768425a223677417$var$L(f, t, !0), $768425a223677417$var$z(this.#i.protocol) === this.#i.port && (this.#i.port = "");
            let s;
            for (s of $768425a223677417$var$V){
                if (!(s in this.#i)) continue;
                let i = {}, o = this.#i[s];
                switch(this.#t[s] = [], s){
                    case "protocol":
                        Object.assign(i, $768425a223677417$var$b), i.encodePart = $768425a223677417$var$w;
                        break;
                    case "username":
                        Object.assign(i, $768425a223677417$var$b), i.encodePart = $768425a223677417$var$he;
                        break;
                    case "password":
                        Object.assign(i, $768425a223677417$var$b), i.encodePart = $768425a223677417$var$ue;
                        break;
                    case "hostname":
                        Object.assign(i, $768425a223677417$var$J), $768425a223677417$var$_(o) ? i.encodePart = $768425a223677417$var$K : i.encodePart = $768425a223677417$var$j;
                        break;
                    case "port":
                        Object.assign(i, $768425a223677417$var$b), i.encodePart = $768425a223677417$var$G;
                        break;
                    case "pathname":
                        $768425a223677417$var$U(this.#n.protocol) ? (Object.assign(i, $768425a223677417$var$Q, l), i.encodePart = $768425a223677417$var$de) : (Object.assign(i, $768425a223677417$var$b, l), i.encodePart = $768425a223677417$var$pe);
                        break;
                    case "search":
                        Object.assign(i, $768425a223677417$var$b, l), i.encodePart = $768425a223677417$var$ge;
                        break;
                    case "hash":
                        Object.assign(i, $768425a223677417$var$b, l), i.encodePart = $768425a223677417$var$me;
                        break;
                }
                try {
                    this.#s[s] = $768425a223677417$var$F(o, i), this.#n[s] = $768425a223677417$var$W(this.#s[s], this.#t[s], i), this.#e[s] = $768425a223677417$var$Ae(this.#s[s], i), this.#l = this.#l || this.#s[s].some((h)=>h.type === 2);
                } catch  {
                    throw new TypeError(`invalid ${s} pattern '${this.#i[s]}'.`);
                }
            }
        } catch (c) {
            throw new TypeError(`Failed to construct 'URLPattern': ${c.message}`);
        }
    }
    get [Symbol.toStringTag]() {
        return "URLPattern";
    }
    test(t = {}, r) {
        let n = {
            pathname: "",
            protocol: "",
            username: "",
            password: "",
            hostname: "",
            port: "",
            search: "",
            hash: ""
        };
        if (typeof t != "string" && r) throw new TypeError("parameter 1 is not of type 'string'.");
        if (typeof t > "u") return !1;
        try {
            typeof t == "object" ? n = $768425a223677417$var$L(n, t, !1) : n = $768425a223677417$var$L(n, $768425a223677417$var$Se(t, r), !1);
        } catch  {
            return !1;
        }
        let c;
        for (c of $768425a223677417$var$V)if (!this.#n[c].exec(n[c])) return !1;
        return !0;
    }
    exec(t = {}, r) {
        let n = {
            pathname: "",
            protocol: "",
            username: "",
            password: "",
            hostname: "",
            port: "",
            search: "",
            hash: ""
        };
        if (typeof t != "string" && r) throw new TypeError("parameter 1 is not of type 'string'.");
        if (typeof t > "u") return;
        try {
            typeof t == "object" ? n = $768425a223677417$var$L(n, t, !1) : n = $768425a223677417$var$L(n, $768425a223677417$var$Se(t, r), !1);
        } catch  {
            return null;
        }
        let c = {};
        r ? c.inputs = [
            t,
            r
        ] : c.inputs = [
            t
        ];
        let l;
        for (l of $768425a223677417$var$V){
            let f = this.#n[l].exec(n[l]);
            if (!f) return null;
            let s = {};
            for (let [i, o] of this.#t[l].entries())if (typeof o == "string" || typeof o == "number") {
                let h = f[i + 1];
                s[o] = h;
            }
            c[l] = {
                input: n[l] ?? "",
                groups: s
            };
        }
        return c;
    }
    static compareComponent(t, r, n) {
        let c = $768425a223677417$var$a((i, o)=>{
            for (let h of [
                "type",
                "modifier",
                "prefix",
                "value",
                "suffix"
            ]){
                if (i[h] < o[h]) return -1;
                if (i[h] === o[h]) continue;
                return 1;
            }
            return 0;
        }, "comparePart"), l = new $768425a223677417$var$P(3, "", "", "", "", 3), f = new $768425a223677417$var$P(0, "", "", "", "", 3), s = $768425a223677417$var$a((i, o)=>{
            let h = 0;
            for(; h < Math.min(i.length, o.length); ++h){
                let p = c(i[h], o[h]);
                if (p) return p;
            }
            return i.length === o.length ? 0 : c(i[h] ?? l, o[h] ?? l);
        }, "comparePartList");
        return !r.#e[t] && !n.#e[t] ? 0 : r.#e[t] && !n.#e[t] ? s(r.#s[t], [
            f
        ]) : !r.#e[t] && n.#e[t] ? s([
            f
        ], n.#s[t]) : s(r.#s[t], n.#s[t]);
    }
    get protocol() {
        return this.#e.protocol;
    }
    get username() {
        return this.#e.username;
    }
    get password() {
        return this.#e.password;
    }
    get hostname() {
        return this.#e.hostname;
    }
    get port() {
        return this.#e.port;
    }
    get pathname() {
        return this.#e.pathname;
    }
    get search() {
        return this.#e.search;
    }
    get hash() {
        return this.#e.hash;
    }
    get hasRegExpGroups() {
        return this.#l;
    }
};
$768425a223677417$var$a($768425a223677417$export$a348b14d2b61192c, "URLPattern");

});





//# sourceMappingURL=Users.28795f8b.js.map
